import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchWishlistItemsPaginated } from '@/common/hooks/useItemWishlist/fetchWishlistItemsPaginated';
import { PagedWishlistItems } from 'generatedBfw/static';

export const WishlistItemsQueryKey = ['wishlist'];

export const usePaginatedWishlistData = () => {
  return useInfiniteQuery<PagedWishlistItems>(
    WishlistItemsQueryKey,
    (context) => fetchWishlistItemsPaginated(context.pageParam),
    {
      getNextPageParam: (lastPage) => {
        return lastPage.totalCount > lastPage.offset ? lastPage.offset + lastPage.limit : 0;
      },
    },
  );
};
